module.exports = __webpack_public_path__ + "static/media/file-document.39eb1cfa.svg";